import React from "react";

function Icon({ fillHover }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='92'
			height='64'
			fill='none'
			viewBox='0 0 92 64'>
			<mask
				id='mask0_413_1648'
				style={{ maskType: "luminance" }}
				width='92'
				height='64'
				x='0'
				y='0'
				maskUnits='userSpaceOnUse'>
				<path fill='#fff' d='M0 0h92v63.363H0V0z'></path>
			</mask>
			<g mask='url(#mask0_413_1648)'>
				<path
					className={fillHover}
					d='M83.571 31.903c-7.675 5.977-12.846 8.147-12.846 8.147s-12.634-4.589-19.95-9.402c-.404-.266.165 2.579 6.106 7.674 2.901 2.489 5.882 4.554 8.07 6.965.941 1.042 1.544 2.285 1.747 3.012.302 1.079.763 2.896-.03 4.947-.84 2.18-2.183 3.462-4.542 4.353-2.578.973-5.737.387-7.258-.368-1.433-.708-2.664-1.683-3.44-2.514-.136-.146-.254-.271-.362-.39.108 1.596.538 3.287 1.84 4.77.827.94 2.4 1.998 3.514 2.681l-12.142-.006c1.338-.9 3.169-2.371 3.89-3.559 1.16-1.904 1.13-3.802 1.13-3.802s-2.946 3.77-7.81 3.77c-5.378 0-8.23-3.717-8.23-6.933 0-6.428 4.703-8.022 13.433-15.882 4.049-3.649 5.56-9.08 5.56-9.08s-19.119-.038-22.738 3.06c-.749-4.928 4.657-11.3 9.268-13.269.44-.19-.376 8.081-.376 8.081L48.69 13.612l-.406 9.613 9.43-8.284-2.351 9.421s14.775-8.118 16.52-15.966c.203-.917.406-1.028-.199-1.464C66.58 3.246 56.98-1.361 44.935.38 32.441 2.186 26.205 8.607 23.21 11.727c0 0-4.118-1.095-5.663-1.34C7.923 8.873-.408 14.234.054 14.467c9.485 4.75 17.042 7.425 16.806 8.288-2.027 7.399-1.309 10.865-.944 12.864-10.8 7.498-9.521 13.49-9.26 13.393 5.32-1.956 12.637-3.098 12.798-2.818 7.896 13.61 22.04 16.225 23.309 16.41a.42.42 0 00.143-.031c2.344.44 4.744.674 7.187.674 2.57 0 5.09-.256 7.554-.742l.03.016s3.159-.592 5.762-1.67c2.612-1.082 4.933-4.097 6.337-8.144.31-.893.66-1.771 1.05-2.634a30.314 30.314 0 012.04-3.775c.959-1.514 1.84-3.148 3.288-4.297 7.516-5.964 7.794-10.39 7.415-10.098h.002zM40.232 4.084c5.052 2.126 10.44 3.432 10.44 3.432s-5.455.343-9.488 2.151c-.292.13-.42-.093-.62-.35-2.25-2.905-.54-5.32-.332-5.233z'></path>
			</g>
		</svg>
	);
}

export default Icon;
